import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportAdministrationComponent } from './report-administration/report-administration.component';

const routes: Routes = [
  { path: '', component: ReportAdministrationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsRouting {}
